import { configureStore } from '@reduxjs/toolkit'
import { AppState } from './app/types'
import { rootReducer } from './rootReducer'
import { UserState } from './user/types'

export interface State {
  user: UserState
  app: AppState
}

export const store = configureStore({ reducer: rootReducer })

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
